// src/services/api.js
// Camada de serviço — toda comunicação com o backend Spring Boot fica aqui.
//
// ┌─────────────────────────────────────────────────────────────────────────┐
// │  Em desenvolvimento o React roda na porta 3000 e o Spring Boot na 8080. │
// │  O "proxy" no package.json redireciona /api/* → localhost:8080,         │
// │  evitando erros de CORS sem precisar configurar nada no backend.        │
// │                                                                          │
// │  Em produção (npm run build) basta servir o build/ na mesma origem      │
// │  do Spring Boot (ex: pasta static/) e o proxy não é mais necessário.   │
// └─────────────────────────────────────────────────────────────────────────┘

// Caminho base da API — usa caminho relativo para funcionar com o proxy
//const API_URL =  "https://ti323.onrender.com/api/produtos" ; //"/api/produtos";
//const API_URL =  "/api/produtos";

const API_URL = process.env.NODE_ENV === "production"
  ? "https://ti323.onrender.com/api/produtos"  // build → URL direta
  : "/api/produtos";         

// ─── Log de conexão no console do browser ───────────────────────────────
// Visível em: F12 → aba Console
const _backend = "https://ti323.onrender.com";
const _u = new URL(_backend);
const _porta = _u.port || (_u.protocol === "https:" ? "443" : "80");
console.log("%c🔌 Backend API (via proxy)", "color:#00ACC1;font-weight:bold;font-size:14px");
console.log("%c  Protocolo : " + _u.protocol.replace(":", ""), "color:#8899AA");
console.log("%c  Host      : " + _u.hostname,                  "color:#8899AA");
console.log("%c  Porta     : " + _porta,                        "color:#8899AA");
console.log("%c  Proxy     : " + _backend + API_URL,            "color:#8899AA");
console.log("%c  URL     : " + API_URL);
console.log("%c  ENV     : " + process.env.NODE_ENV);
// ─── Utilitário interno ──────────────────────────────────────────────────
// Extrai a mensagem de erro de uma resposta HTTP mal-sucedida.
// O Spring Boot geralmente devolve JSON com campo "message" ou "error".
async function extrairErro(response) {
  try {
    const body = await response.json();
    return body.message || body.error || `Erro HTTP ${response.status}`;
  } catch {
    return `Erro HTTP ${response.status}`;
  }
}

// ─── CONSULTAR TODOS (GET /api/produtos) ────────────────────────────────
// Retorna: Produto[]
export async function getProdutos() {
  const response = await fetch(API_URL);
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── CONSULTAR POR ID (GET /api/produtos/{id}) ──────────────────────────
// Retorna: Produto | lança erro 404 se não encontrado
export async function getProdutoById(id) {
  const response = await fetch(`${API_URL}/${id}`);
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── INSERIR (POST /api/produtos) ───────────────────────────────────────
// Body: { nome: String, preco: Double, estoque: Integer }
// Retorna: Produto criado (com id gerado pelo banco)
export async function createProduto(produto) {
  const response = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(produto),
  });
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── ALTERAR (PUT /api/produtos/{id}) ───────────────────────────────────
// Body: { nome: String, preco: Double, estoque: Integer }
// Retorna: Produto atualizado
export async function updateProduto(id, produto) {
  const response = await fetch(`${API_URL}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(produto),
  });
  if (!response.ok) throw new Error(await extrairErro(response));
  return response.json();
}

// ─── APAGAR (DELETE /api/produtos/{id}) ─────────────────────────────────
// Retorna: true em caso de sucesso
// Aceita resposta 200 com corpo OU 204 sem corpo (ambos comuns no Spring Boot)
export async function deleteProduto(id) {
  const response = await fetch(`${API_URL}/${id}`, {
    method: "DELETE",
  });
  if (!response.ok) throw new Error(await extrairErro(response));
  return true;
}
